import { Input } from '~/components/Input'
import { MaskedInput } from '~/components/MaskedInput'
import { Select } from '~/components/Select'

const provinces = [
  { value: 'AB', text: 'Alberta' },
  { value: 'BC', text: 'British Columbia' },
  { value: 'MB', text: 'Manitoba' },
  { value: 'NB', text: 'New Brunswick' },
  { value: 'NL', text: 'Newfoundland and Labrador' },
  { value: 'NS', text: 'Nova Scotia' },
  { value: 'ON', text: 'Ontario' },
  { value: 'PE', text: 'Prince Edward Island' },
  { value: 'QC', text: 'Quebec' },
  { value: 'SK', text: 'Saskatchewan' },
  { value: 'NT', text: 'Northwest Territories' },
  { value: 'NU', text: 'Nunavut' },
  { value: 'YT', text: 'Yukon' },
]
export const Address = () => {
  return (
    <div className="">
      <div className="text-lg font-semibold text-primary-green">Mailing Address</div>
      <div className="flex flex-wrap justify-start">
        <Input name="addressLine1" label="Street Address" />
        <Input name="addressLine2" label="Unit / Apt (optional)" />
        <Input name="city" label="City" />
        <Select name="province" label="Province or Territory" options={provinces} />
        <MaskedInput name="postalCode" label="Postal Code" options={{ blocks: [3, 3] }} />
        <Input name="country" label="Country" value="Canada" disabled={true} />
      </div>
    </div>
  )
}
